import React, { ReactNode } from "react";
import { Container } from "./style";

interface IHeaderPageProps {
  title: ReactNode;
  subtitle: ReactNode;
}

export const PageHeader: React.FC<IHeaderPageProps> = ({ title, subtitle }) => {
  return (
    <Container>
      <span className="title">{title}</span>
      <span className="sub-title">{subtitle}</span>
    </Container>
  );
};
